import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface OptionSwitchItem {
    label: string;
    value: any;
}

@Component({
    selector: 'glo-option-switch',
    imports: [CommonModule],
    templateUrl: './option-switch.component.html'
})
export class OptionSwitchComponent implements OnInit {
    @Input() options: OptionSwitchItem[] = [];
    @Input() selected: string = '';
    @Output() changed = new EventEmitter<string>();

    ngOnInit(): void {
        console.log("selected", this.selected, this.options, this.options[0].value);
        if (!this.selected && this.options.length > 0) {
            this.selected = this.options[0].value;
            // this.changed.emit(this.selected);
        }
    }

    select(value: string): void {
        if (this.selected !== value) {
            this.selected = value;
            this.changed.emit(value);
        }
    }
}
